<template>

  <section class="section-video">
    <ExpanderVideo filename="1080.mp4" :mobile="mobile" url="https://helthjem.no/" :autoplay="true" @track="track" />
  </section>

  <section class="section-main">
    <div class="container">
      <div class="image">
        <div class="img">
          <img src="@/assets/image.jpg">
        </div>
      </div>
      <div class="text">
        <img src="@/assets/logo-2.svg" width="140" class="logo">
        <h1 class="heading">Julegaveguide 2023</h1>
        <p class="lead">
          Hadde det ikke vært deilig å gjøre unna julehandelen fra sofaen i år? Vi har gjort det enkelt, og samlet våre beste tips og gode rabatter til deg. 
        </p>
        <p class="lead">
          Så senk skuldrene, bak noen pepperkaker, og få julegavene levert heeeeelt hjem👇🏼👇🏼
        </p>
      </div>
    </div>
  </section>

  <section class="section-brands">
    <div class="scroll">
      <h1 class="title">Snarveier:</h1>
      <div class="items">
        <button class="brand" v-for="brand, index in brands" :key="brand" @click="scrollToBrand(index)">{{ brand.name }}</button>
      </div>
    </div>
  </section>

  <section class="section-brand" :class="`section-brand-${index}`" v-for="brand, index in brands" :key="brand">
    <HelthjemBrand :item="brand" :altLayout="!!(index % 2)" @track="track" />
  </section>

  <section class="section-info">
    <h1 class="heading">Sende julegave?</h1>
    <p class="lead">
      Om du skal sende julegaver til noen du er glad i, så bør du sende dem i god tid før 16. desember. Det er nemlig aller siste frist for å sende pakker slik at de kommer fram til jul. Skal du sende julegaver til noen du ikke er glad i så kan du sende pakkene etter dette, men da vet du altså konsekvensene.😇
    </p>
    <div class="items">
      <div class="item">
        <div class="image">
          <img src="@/assets/cliparts/phone.png">
        </div>
        <h2 class="title">Bestill henting</h2>
        <p>
          Etter betaling får du en kode, som du skriver tydelig på pakken. Du kan gjerne skrive på mottakers navn også.
        </p>
      </div>
      <div class="item">
        <div class="image">
          <img src="@/assets/cliparts/gifts.png">
        </div>
        <h2 class="title">Legg pakken ut</h2>
        <p>
          Legg pakken ut innen kl. 23. Du får en e-post med beskjed om du skal legge pakken på dørmatten eller i postkassen din.
        </p>
      </div>
      <div class="item">
        <div class="image">
          <img src="@/assets/cliparts/moon.png">
        </div>
        <h2 class="title">Pakken hentes</h2>
        <p>
          Vi henter pakken hjemme hos deg i løpet av natten, og sender den til mottaker.
        </p>
      </div>
    </div>
    <div class="actions">
      <a href="https://helthjem.no/" target="_blank" class="cta send" @click="track('send-pakke')">Send pakke</a>
    </div>
  </section>

  <footer class="section-footer">
    <a href="https://helthjem.no/" target="_blank" class="logo" @click="track('logo')">
      <img src="@/assets/logo-1.svg" alt="Helthjem" width="200">
    </a> 
    <div class="items">
      <p>Få julegavene levert heeeelt hjem </p>
      <a href="https://helthjem.no/" target="_blank" class="cta" @click="track('cta')">Les mer</a>
    </div>
  </footer>


</template>

<script>
  import ExpanderVideo from './components/ExpanderVideo.vue'
  import HelthjemBrand from './components/HelthjemBrand.vue'

  export default {
    name: 'App',
    components: {
      ExpanderVideo,
      HelthjemBrand,
    },
    data() {
      return {
        version: 1,
        mobile: false,
        copied: false,
        resourcesId: 2261,
        brands: [
          {
            name: 'Pierre Robert',
            logo: 'pierre-robert.svg',
            heading: 'Ull, ull, deilig ull!',
            lead: 'Det er umulig å få nok av ull på denne tiden av året, og Pierre Robert har ull for alle anledninger. Tidløst design og deilig kvalitetsull gjør dette perfekt både som gave og til deg selv.',
            note: '*Rabatten kan ikke kombineres med andre tilbud/ rabatter. Rabatten gjelder ikke Blazer og Dressbukse',
            code: 'HELTHJEM20',
            url: 'https://www.pierrerobert.no/',
            items: [
              [
                'CARDIGAN MED STRUKTUR',
                'Tidløs, jacquard mønstret cardigan i myk, svanemerket. merinoull',
                'Cardigan-ull-med-struktur-svart-2.jpg',
                'https://www.pierrerobert.no/no_NO/cardigan/SB62.html',
                '-20%',
              ],
              [
                'GENSER MED AVTAGBAR HALS',
                'Ribbestrikket genser med avtagbar hals i myk svanemerket merinoull.',
                'Ull-genser-avtagbar-hals-9.jpg',
                'https://www.pierrerobert.no/no_NO/ullgenser_avtagbar_hals/SB64.html?dwvar_SB64_color=Blue%2FIvory%20stripe&cgid=Capsule#sz=24&start=1',
                '-20%',
              ],
              [
                'ULLSINGLET JANKA POLLIANI X PIERRE ROBERT',
                'Singlet designet i samarbeid med stilikonet Janka Polliani',
                'Janka_Polliani_svart_sort_ullsinglet_1.jpg',
                'https://www.pierrerobert.no/no_NO/ullsinglet_janka_polliani/O133.html',
                '-20%',
              ]
            ]
          },
          {
            name: 'BikBok',
            logo: 'bikbok.svg',
            heading: 'Fra lounge til fest',
            lead: 'Hva slår å få et komfortabelt loungesett levert rett på dørmatta? Kanskje å få levert to – én til deg og én til noen som fortjener litt ekstra komfort til jul. Eller hva med et nytt festantrekk til jul eller nyttårsaften?',
            note: '*Tilbudet gjelder ved kjøp av 2 eller flere. Gjelder ord.pris. Kan ikke kombineres med andre tilbud.',
            code: 'helthjem20',
            url: 'https://bikbok.com/no',
            items: [
              [
                'Mega Hettegenser',
                'En hoodie i myk og deilig bomull, med fôret hette, og stor lomme foran.',
                '7356672_950_f_m_mh_179_ms_s_sh_mega_bikbok__1.avif',
                'https://bikbok.com/no/p/mega-hettegenser-gra-overdeler-hoodie-dame/7356672_F950',
                '-20%',
              ],
              [
                'Harper velur kjole',
                'En kjole i velur stoff av resirkulert polyester.',
                '7356414_990_f_m_mh_178_ms_s_dk_harper_bikbok__1_1.jpg',
                'https://bikbok.com/no/p/harper-velur-kjole-svart-kjoler--skjort-kjoler-dame/7356414_F990',
                '-20%',
              ],
              [
                'Rhinestone veske',
                'Kort håndtak og dekket med rhinestones. Perfekt for finere anledninger.',
                '7357744_040_f_m_mh_178_ms_s_ap_party_bikbok.avif',
                'https://bikbok.com/no/p/party-rhinestone-veske-solv-accessories-vesker-dame/7357744_F040',
                '-20%',
              ]
            ]
          },
          {
            name: 'Lyko',
            logo: 'lyko.png',
            heading: 'Velvære til hele familien',
            lead: 'Hos Lyko finner du gaver til hele familien. En ny barberhøvel til pappa og en deilig hårolje til mamma? Kanskje du har en bror som trenger post poo-drops for familiens skyld?',
            note: '*Gjelder ordinærpris. Kan ikke kombineres med andre tilbud. Visse produkter og varemerker er eksludert fra rabatten, disse markeres med som “kan ikke kombineres med rabattkoder” på produktet og i kassen hos Lyko',
            code: 'HELTHJEM',
            url: 'https://lyko.com/no',
            items: [
              [
                'Origins Drink Up Intensive Overnight Mask 75 ml',
                'Ekstra fuktighetsgivende maske som øyeblikkelig skjemmer bort huden med intensiv fuktighetspleie',
                'origins-drink-up-intensive-overnight-mask-75-ml-3497-100-0075_1.jpg',
                'https://lyko.com/no/hudpleie/ansikte/ansiktsmaske/origins-drink-up-intensive-overnight-mask-75-ml',
                '-15%',
              ],
              [
                'Mühle Barberhøvel R89',
                'Mühle R89 er en kjent klassiker blant barberhøvler. Den er godt balansert og passer både for nybegynnere og mer erfarne.',
                'muhle-sakerhetshyvel-r89-1962-122-0000_1.jpg',
                'https://lyko.com/no/mann/barbering/barberhovel/muhle-sakerhetshyvel-r89',
                '-15%',
              ],
              [
                'Olaplex Bonding Oil No.7 30 ml',
                'Ekstremt konsentrert, fjærlett og reparerende stylingolje som gir utrolig glans, styrker, mykgjør og forbedrer kvaliteten på alle hårtyper.',
                'olaplex-no7-bonding-oil-30-ml-1737-110-0030_1.jpg',
                'https://lyko.com/no/harpleie/harpleie/behandling/harolje/olaplex-no7-bonding-oil-30-ml',
                '-15%',
              ]
            ]
          },
          {
            name: 'The Body Shop',
            logo: 'the-body-shop.png',
            heading: 'Julegaver med god samvittighet',
            lead: 'The Body Shop har noe for alle - og det beste er at alle produktene deres er veganske, økologiske og bærekraftige.',
            note: '*Kan ikke kombineres med andre tilbud. Gjelder i en begrenset periode, på utvalgte produkter. Gjelder ved kjøp over 200kr.',
            code: 'HELTHJEM20',
            url: 'https://www.thebodyshop.no/gaver/julegaver',
            items: [
              [
                'British Rose Essentials Gift',
                'Kjenner du noen som elsker duften av roser? Overrask dem med vår British Rose Essentials Gift!',
                '1038651_g3_small_british_rose_xm23_bronze_nw_inafvps036_1_.jpg',
                'https://www.thebodyshop.no/g3-british-rose',
                '-20%'
              ],
              [
                'Shea Big Gift',
                'Skjem bort noen du er glad i med vår velduftende Shea Big Gift!',
                '1039336_g4_medium_shea_xm23_a0x_bronze_nw_inafvps042.jpg',
                'https://www.thebodyshop.no/g4-medium-shea-xm23',
                '-20%'
              ],
              [
                'Strawberry Treats',
                'Gi myk og velduftende hud i gave med vår Strawberry Treats!',
                '1038596_g1_treats_strawberry_xm23_a0x_bronze_nw_inafvps027.jpg',
                'https://www.thebodyshop.no/g1-treats-strawberry-xm23',
                '-20%'
              ]
            ]
          },
          {
            name: 'Makeup Mekka',
            logo: 'makeup-mekka.png',
            heading: 'Prikken over i’en',
            lead: 'Ute etter den perfekte venninnegaven? Gi bort den perfekte hverdagskremen, et øyenskyggepallett og noen nye hoops, eller unn deg selv noe ekstra under treet i år!',
            note: '*Kan ikke kombineres med andre tilbud. Gjelder ikke julekalender og kits.',
            code: 'Helthjem30',
            url: 'https://www.makeupmekka.com/no-no/?utm_source=julegaveguide&utm_medium=cpc&utm_campaign=helthjem',
            items: [
              [
                'SILKY BRUSH & SPONGE SET',
                'Alle trenger et godt kostesett! Dette er et fullt kostesett, med alle kostene du trenger til din daglige makeuprutine',
                'Makeup-Mekka-.jpg',
                'https://www.makeupmekka.com/no-no/produkt/silky-brush--sponge-set?utm_source=julegaveguide&utm_medium=cpc&utm_campaign=helthjem',
                '-30%',
              ],
              [
                'BEIGE NECESSITY MAKEUP BAG',
                'Dette er en praktisk, mindre sminkemappe. Den rommer alle dine must-haves og er perfekt til hverdagsbruk! Laget av syntetisk lær som er enkelt å rengjøre.',
                'Makeup-Mekka-Beige-Necessity-Makeup-Bag.jpg',
                'https://www.makeupmekka.com/no-no/produkt/xxl-makeup-bag?utm_source=julegaveguide&utm_medium=cpc&utm_campaign=helthjem',
                '-30%',
              ],
              [
                'OH SO BEAUTIFUL EYESHADOW PALETTE',
                'Oh So Beautiful Eyeshadow Palette består av tjue forskjellige øyenskygger, med tolv matte skygger og åtte skimmer skygger.',
                'Makeup-Mekka-Oh-So-Beautiful-Eyeshadow-Palette.jpg',
                'https://www.makeupmekka.com/no-no/produkt/oh-so-beautiful-eyeshadow-palette?utm_source=julegaveguide&utm_medium=cpc&utm_campaign=helthjem',
                '-30%',
              ]
            ]
          },
          {
            name: 'Kondomeriet',
            logo: 'kondomeriet.png',
            heading: 'Julegaver som vibrerer',
            lead: 'Kondomeriet har julegavene som får deg til å komme… i julestemning! Pirrende favoritter til både ham, henne og par.',
            note: '*Gjelder ordinære produkter og kan ikke kombineres med andre rabattkoder og tilbud.',
            code: 'HETJUL20',
            url: 'https://www.kondomeriet.no/',
            items: [
              [
                'Womanizer Liberty Lilla',
                'Få utrolige klitorisorgasmer med Womanizer Liberty. Praktisk magnetlokk følger med, slik at du enkelt og diskré kan ha den i håndveska.',
                '118284-womanizer-liberty-lilla-med-eske.jpg',
                'https://www.kondomeriet.no/sexleketoy/passer-for/sexleketoy-for-henne/womanizer-liberty-lilla/',
                '-20%',
              ],
              [
                'Mer Lyst Fristende Fleshlight 2',
                'Mer Lyst Fristende Fleshlight 2 er Kondomeriets egne Fleshlight!',
                '120981-ml-fristende-fleshlight-2-4.webp',
                'https://www.kondomeriet.no/sexleketoy/passer-for/sexleketoy-for-ham/mer-lyst-fristende-fleshlight-2/',
                '-20%',
              ],
              [
                'Kondomeriets orgasmekrem 50 ml',
                'Gi bort en orgasmek! Denne fantastiske kremen kan gi både lengre, sterkere og raskere orgasme.',
                '114359_kondomeriets_orgasmekrem_nyttbilde.jpg',
                'https://www.kondomeriet.no/tilbehor/kondomeriets-orgasmekrem-50-ml/?perform=category',
                '-20%',
              ]
            ]
          },
          {
            name: 'FINN',
            logo: 'finn.png',
            heading: 'Like bra brukt - like god jul!',
            lead: 'Skulle du ønske at det var *litt* lettere å handle brukte julegaver? Det er det nå! Her har vi samlet de mest populære julegavene på FINN torget i 2023, sånn at du kan handle alle julegavene brukt i år. God fornøyelse! ❤️',
            url: 'https://www.finn.no/bap/artikler/15-populaere-julegavetips-fra-finn-2023?&utm_source=helthjem&utm_medium=linkv&utm_campaign=tjt23w48&utm_content=juleguide',
            items: [
              [
                'Brukt festkjole',
                'Brukt festkjole, nye moves. Kjøp en fin festkjole til noen du er glad i - eeeller deg selv!',
                'kjole.jpg',
                'https://www.finn.no/bap/forsale/search.html?product_category=2.71.3941.172&q=%22bytimo%22+OR+%22rotate%22+OR+%22hale+bob%22+OR+%22ganni%22+OR+%22zimmermann%22+OR+%22by+timo%22+OR+%22ella%26il%22+OR+%22pia+tjelta%22+OR+%22love+lolita%22&shipping_exists=true&utm_campaign=tjt23w48&utm_content=kjole&utm_medium=linkv&utm_source=helthjem',
              ],
              [
                'Patagonia eller Moncler',
                'Pynt eller på tur! Gi bort Patagonia eller Moncler til jul? Mye av begge på FINN!',
                'patagonia.jpg',
                'https://www.finn.no/bap/forsale/search.html?product_category=2.71.3950.183&q=patagonia+OR+moncler&shipping_exists=true&utm_campaign=tjt23w48&utm_content=jakke&utm_medium=linkv&utm_source=helthjem',
              ],
              [
                'Lego',
                'Gi bort et byggeprosjekt! Lego er en av FINNs mest solgte leker!',
                'lego.jpg',
                'https://www.finn.no/bap/forsale/search.html?gsq=Lego%3A81d602780da6&product_category=2.68.3912.333&shipping_exists=true&utm_campaign=tjt23w48&utm_content=lego&utm_medium=linkv&utm_source=helthjem',
              ]
            ]
          },
          {
            name: 'VOLT',
            logo: 'volt-logo.svg',
            heading: 'Til han som har alt',
            lead: 'Hos Volt finner du alt fra deilige merinoullgensere til sokker og boksere som man aldri får nok av. ',
            note: '*Tilbudet gjelder ved kjøp av 2 eller flere produkter fra These Glory Days. Gjelder ord. pris, kan ikke kombineres med andre tilbud.',
            code: 'Helthjem30',
            url: 'https://voltfashion.com/no/',
            items: [
              [
                'Brice Half Zip Genser',
                'Myk og behagelig strikket genser laget av 100 % merinoull.',
                '7253211_583_d1_m_these_glory_days_mh_191_ms_m_t_brice_half_zip_volt.jpg',
                'https://voltfashion.com/no/p/these-glory-days-brice-half-zip-genser-navy-gensere-strikkede-gensere-herre/7253211_F583',
                '-30%',
              ],
              [
                'Bob Blazer',
                "Enkeltspent blazer laget i Super 100's ull.-",
                '7352122_593_f_m_these_glory_days_mh_188_ms_50_t_bob_blazer_sf_volt.jpg',
                'https://voltfashion.com/no/p/these-glory-days-bob-blazer-super-100s--dresser-dressjakker-herre/7352122_F593',
                '-30%',
              ],
              [
                'Dino Oxfordskjorte',
                'Semi-formell nedkneppet krage, knapper foran og meislede mansjetter.',
                '7347430_500_f_m_these_glory_days_mh_191_ms_m_t_dino_oxford_bd_shirt_sf_volt.jpg',
                'https://voltfashion.com/no/p/these-glory-days-dino-oxfordskjorte-lys-bla-skjorter-finskjorter-herre/7347430_F500',
                '-30%',
              ]
            ]
          }
        ]
      }
    },
    created() {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      let id = params.get('version')
      if (id == 2) {
        this.version = 2
      }
    },
    methods: {
      scrollToBrand(index) {
        document.querySelector(`.section-brand-${index}`)?.scrollIntoView({behavior: 'smooth'})
        this.track(`scroll-to-${this.brands[index].name}`)
      },
      track(label) {
        console.info('track', label)
        window.ad10Resources?.trackAction(`${this.resourcesId}-${label}`)
      },
    },
  }
</script>

<style lang="scss">
  @import "node_modules/minireset.css/minireset";
  @import '@/scss/fonts.scss';
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';


  html {
    font-family: $font, sans-serif;
    font-size: 16px;
    font-weight: $weight;
    color: $color-text;
    text-align: left;
    line-height: 1.3;
    @include desktop {
      font-size: 1.48vw;
    }
    @media (min-width: $width) {
      // font-size: 12px;
      font-size: 14px;
    }
  }
  #app {
    position: relative;
    width: $width;
    max-width: 100%;
    margin: 0 auto;
    background: $color-bg;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-bottom: var(--footer-height);
  }

  img {
    display: block;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  p {
    font-size: 1rem;
  }
  button {
    font-family: $font;
    font-size: 1rem;
    padding: 0;
    border: 0;
    background: none;
    outline: 0 none;
    cursor: pointer;
  }

  .cta {
    display: inline-block;
    padding: 0.5rem 1.25rem;
    font-size: 0.625rem;
    font-weight: 600;
    border-radius: 3.125rem;
    color: #fff;
    background: $color-1;
    transition: background .15s;
    white-space: nowrap;
    @include d {
      padding: 0.625rem 1.5rem;
      font-size: .75rem;
    }
    &:hover {
      background: darken($color-1, 10%);
    }
    &.alt {
      background: $color-2;
      color: $color-text;
      &:hover {
        background: darken($color-2, 10%);
      }
    }
    &.external {
      &::after {
        content: '';
        position: relative;
        top: .0625rem;
        display: inline-block;
        width: .75rem;
        height: .75rem;
        margin-left: .25rem;
        background: url('assets/icons/external-black.svg') no-repeat center center / contain;
      }
      &.alt {
        &::after {
          background-image: url('assets/icons/external.svg');
        }
      }
    }
    &.send {
      &::before {
        content: '';
        position: relative;
        top: .25rem;
        display: inline-block;
        width: 1rem;
        height: 1rem;
        margin-right: .25rem;
        background: url('assets/icons/send.svg') no-repeat center center / contain;
      }
      &.alt {
        &::after {
          background-image: url('assets/icons/external.svg');
        }
      }
    }
  }


</style>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  .section-main {
    padding: 4rem 1rem;
    @include d {
      // padding: 7.5rem;
      padding: 5rem;
    }
    .container {
      padding: 1.5rem;
      background: linear-gradient(to bottom, $color-3 10.625rem, #FFF8EA 10.625rem);
      border-radius: 1.875rem;
      @include d {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;
        padding: 3.5rem 10.625rem 3.5rem 8.125rem;
        background: linear-gradient(to left, $color-3 21.5rem, #FFF8EA 21.5rem);
      }
    }
    .image {
      position: relative;
      @include d {
        width: 21.5rem;
        &::before {
          content: '';
          position: absolute;
          left: -5.25rem;
          bottom: -1.625rem;
          width: 13.375rem;
          height: 10.625rem;
          background: url('assets/cliparts/julegaver.png') no-repeat center center / contain;
        }
      }
      .img {
        border: 18px solid #FFF8EA;
        overflow: hidden;
        border-radius: 10rem 10rem 2rem 2rem;
        @include d {
          border-radius: 15.625rem 15.625rem 0 0;
        }
      }
      img {
        width: 100%;
        max-width: none;
        aspect-ratio: 268/190;
        object-fit: cover;
        @include d {
          aspect-ratio: 300/384;
        }
      }
    }
    .text {
      padding: 2rem 0 0;
      @include d {
        width: 26.25rem;
      }
    }
    .logo {
      margin-bottom: 1.5rem;
      width: 7rem;
      @include d {
        width: 8.75rem;
      }
    }
    .heading {
      position: relative;
      margin-bottom: .875rem;
      font-weight: 900;
      font-size: 1.75rem;
      color: $color-1;
      @include d {
        font-size: 2.5rem;
      }
      &:before {
        content: '';
        position: absolute;
        left: -.375rem;
        top: .125rem;
        width: 1.1875rem;
        height: 1rem;
        background: url('assets/cliparts/cap.png') no-repeat center center / contain;
        transform: rotate(10deg);
        @include d {
          width: 1.5rem;
          height: 1.25rem;
          transform: none;
        }
      }
    }
    .lead {
      margin-bottom: 1.25rem;
      font-size: .875rem;
      @include d {
        font-size: 1rem;
      }
    }
  }

  .section-brands {
    position: sticky;
    top: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    padding: .75rem 0 .75rem 1rem;
    background: #F8F5F3;
    border-bottom: 1px solid #E8E0DB;
    @include d {
      justify-content: center;
    }
    .title {
      font-size: .625rem;
      font-weight: bold;
      @include d {
        font-size: .75rem;
      }
    }
    .scroll {
      display: flex;
      align-items: center;
      overflow: auto;
      -ms-overflow-style: none;  /* Internet Explorer 10+ */
      scrollbar-width: none;  /* Firefox */
    }
    .scroll::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
    }
    .items {
      display: inline-flex;
      padding: 0 .625rem;
      .brand {
        padding: 0.375rem 1.125rem;
        font-size: 0.625rem;
        font-weight: 600;
        border-radius: 3.125rem;
        border: 1.5px solid #619981;
        white-space: nowrap;
        transition: .15s;
        &:hover {
          background: #619981;
          color: #fff;
        }
        @include d {
          padding: .5rem 1.5rem;
          font-size: .75rem;
        }
      }
      .brand + .brand {
        margin-left: .625rem;
        @include d {
          margin-left: 1rem;
        }
      }
    }
  }

  .section-info {
    padding: 5rem 1.5rem;
    @include d {
      padding: 7.5rem;
      text-align: center;
    }
    .heading {
      margin-bottom: 1rem;
      font-size: 1.75rem;
      font-weight: 900;
      color: #EC693B;
      @include d {
        margin-bottom: 1.5rem;
        font-size: 2.5rem;
      }
    }
    .lead {
      font-size: 0.875rem;
      color: #050505;
      font-weight: 400;
      line-height: 1.5rem;
      @include d {
        max-width: 50rem;
        margin: 0 auto 4rem;
        font-size: 1rem;
        line-height: 1.5rem;
      }
    }
    .items {
      text-align: center;
      @include d {
        display: flex;
        justify-content: center;
      }
    }
    .item {
      max-width: 20.5rem;
      margin: 3rem auto 0;
      @include d {
        max-width: 24rem;
        margin: 0 1rem;
      }
      .image {
        width: 8rem;
        margin: 0 auto;
      }
      .title {
        margin: .625rem 0;
        font-size: 1.25rem;
        line-height: 125.682%;
        @include d {
          font-size: 1.375rem;
        }
      }
      p {
        font-size: 0.75rem;
        line-height: 125.682%;
        color: #4d4d4d;
        @include d {
          font-size: .875rem;
        }
      }
    }
    .actions {
      margin-top: 3rem;
      text-align: center;
      .cta {
        display: inline-flex;
        align-items: center;
        font-size: .75rem;
        font-weight: 900;
        &::before {
          top: auto;
        }
      }
    }
  }

  .section-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // height: var(--footer-height);
    padding: 2.5rem 1rem;
    background: $color-3;
    @include d {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 1.25rem 7rem;
    }
    .logo {
      width: 8rem;
      margin-bottom: .75rem;
      @include d {
        width: 8.125rem;
        margin-bottom: 0;
      }
    }
    .items {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @include d {
        flex-direction: row;
        align-items: center;
      }
      p {
        margin-bottom: .75rem;
        font-size: .75rem;
        @include d {
          margin-bottom: 0;
          margin-right: 1rem;
          font-size: .875rem;
        }
      }
    }
  }

</style>
